import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import CountryDocument from "../../Sections/CountrKycDocumentation";

const CountryComponent = () => {
    return (
        <Dashboard sectionName={<CountryDocument/>}/>
    );
};

export default CountryComponent;